export default {
  logo: "yuxinjiyin",
  common: {
    welcome: "Welcome",
    about: "About Us",
    contact: "Contact",
    newCenter: "News Center",
    instrument: "Instrument",
    home: 'Home',
    product: 'Product',
    solution: 'Solution',
    newsCenter: 'News Center',
    aboutUs: 'About Us',
    joinUs: 'Join Us',
    contactUs: 'Contact Us',
    recruitment: 'Recruitment'
  },
  productList: {
    instrument: "Instrument",
    reagent: 'Reagent',
    software: 'Software'
  }


}



// WEBPACK FOOTER //
// ./src/i18n/locales/en-US.js